import {Controller} from "@hotwired/stimulus";
import {useIntersection} from 'stimulus-use'
import device from "../../js/device";
import {hasIntersectionObserver} from '../../js/window-has';

/* stimulusFetch: 'lazy' */
export default class extends Controller {

    GAP = 250;
    rendering = true;
    page = 0;
    rightbarAdvCounter = 1;


    static targets = ['container', 'placeholder'];
    static values = {
        url: String,
        hasAdv: {type: Boolean, default: true}
    }

    async connect() {
        if (hasIntersectionObserver()) {
            useIntersection(this, {
                element: this.placeholderTarget,
            })
        } else {
            await this.appear()
        }
    }

    async appear() {

        if (device.getType() !== 'desktop' || this.rendering === false || this.page >= 20) {
            return;
        }

        const diff = this.element.previousElementSibling.clientHeight - this.element.clientHeight

        /*
        *
        console.log('bar margi', getComputedStyle(this.element).marginTop)
        console.log('prev heigth', this.element.previousElementSibling.clientHeight);
        console.log('bar heigth', this.element.clientHeight);
        console.log('bar diff', diff);
        */

        if (diff >= this.GAP) {


            if (this.page % 2 === 0) {

                if (this.hasAdvValue) {
                    this.containerTarget.insertAdjacentHTML('beforeend', this.getAdv(this.rightbarAdvCounter))
                    this.rightbarAdvCounter++;
                }

            } else {

                const params = new URLSearchParams({
                    page: this.page
                });

                const response = await fetch(`${this.urlValue}?${params.toString()}`);

                if (!response?.ok || response.status === 204) {
                    this.rendering = false;
                    return;
                }

                this.containerTarget.insertAdjacentHTML('beforeend', await response.text())

            }

            this.page++;

            await this.appear();

        }


    }


    getAdv(counter) {

        if (counter > 4) {
            return '';
        }


        return `
        <div class="hidden md:flex adv-desktop-vertical">
        <div 
        id="rightbar-desktop-${counter}" 
        data-controller="adv" 
        data-adv-ad-unit-value="&#x2F;22272936144&#x2F;calciomercato&#x2F;calciomercato_web&#x2F;articles&#x2F;middlempu${counter}" 
        data-adv-element-id-value="rightbar-desktop-${counter}" 
        data-adv-sizes-value="&#x5B;&#x5B;1,1&#x5D;,&#x5B;300,250&#x5D;,&quot;fluid&quot;&#x5D;" 
        data-adv-force-value="true" 
        data-adv-device-value="desktop"
        class="sticky top-3"
        ></div></div>`
    }

}